import { render, staticRenderFns } from "./ZonasForm.vue?vue&type=template&id=62f18390&scoped=true"
import script from "./ZonasForm.vue?vue&type=script&lang=js"
export * from "./ZonasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f18390",
  null
  
)

export default component.exports